const RTBHouseProductCard = (productID: number, productName: string, productPrice: string) => {
  if (window?.rtbhEvents && Array.isArray(window.rtbhEvents)) {
    window.rtbhEvents.push({
      eventType: 'viewProduct',
      productName,
      productId: productID,
      productPrice
    });
  }
};
export default RTBHouseProductCard;